module.exports = __webpack_public_path__ + "static/media/D1.0d805e3a.png";